import React, { useState } from 'react'
import ButtonMUI from '@material-ui/core/Button';

function Form(props) {
  const [msg, setMsg] = useState("")

  function sendSms(number) {

    let data = {
      data: {
        addresses: [number],
        message: msg,
       target_device_iden: "uju3xnTbzQisjESBmyFWsC",
      }
    }

    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;

    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        console.log(this.responseText);
      }
    });

    xhr.open("POST", "https://api.pushbullet.com/v2/texts");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Access-Token", "o.WaeMIx2VczAs4SBKdYC3M76QPUfJpbUG");
    xhr.send(JSON.stringify(data));
    console.log("Poslao na: " + number)
  }


  const handleClick = () => {
    props.numbers.map(x => sendSms(x))
  }



  const handleChange = (e) => {
    setMsg(e.target.value)
  }
  return (
    <div style={{ display: 'flex' }}>
      <ButtonMUI style={{ margin: '20px' }} variant="contained" color="primary" onClick={handleClick}>
        Send
    </ButtonMUI>
      <textarea type="text" value={msg} onChange={handleChange} />
    </div>
  )
}


export default Form